import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Paper from "../../../Components/UI/Paper";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Button from "@mui/material/Button";

import { useNavigate } from "react-router-dom";
import useTimeout from "Hooks/useTimeout";
import { useAuth } from "Hooks/useAuth";
import EndcustomerForm from "Components/Endcustomer/EndcustomerForm";
import { useEndCustomers } from "Context/EndCustomers";
import { useClients } from "Context/Clients";
import { COUNTRYCODE } from "utils/options/COUNTRYCODE";
import { LANGUAGECODE } from "utils/options/LANGUAGECODE";
import { AGREEMENT_OPTIONS } from "utils/options/AGREEMENT_OPTIONS";
import { BOOLVALUE } from "utils/options/BOOLVALUE";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { LoadingButton } from "@mui/lab";

const initialState = {
  EndCustomerId: "",
  OrgNo: "",
  Name: "",
  Name2: "",
  Address: "",
  Address2: "",
  PostalCode: "",
  City: "",
  CountryCode: "SE",
  ExternalCustomerNr: "",
  LatePaymentInterestPercentage: "",
  OriginalFfd: "",
  Pm1Ffd: "",
  Pm1Fee: "",
  Pm1WaitCreate: "",
  Pm2Ffd: "",
  Pm2Fee: "",
  Pm2WaitCreate: "",
  CollectionWaitCreate: "",
  DefaultAgreement: "",
  SameAgreementAsClient: 1,
  ClientId: null,
};

export function CreateEndCustomer({ onClose }) {
  const [formData, setFormData] = useState(initialState);
  const { clients, loading, fetchClients } = useClients();
  const { createEndCustomer, loading: loadingEndCustomers } = useEndCustomers();
  const navigate = useNavigate();

  const timeout = useTimeout(() => navigate("/endcustomers"), 1100, false);
  const { openError } = usePopupNotificationContext();

  const handleOnCreate = async () => {
    if (loadingEndCustomers) return;
    const res = await createEndCustomer(formData);
    if (res.status === 201) {
      onClose ? onClose() : navigate(`/endcustomers/${res.data.Id}`);
    } else {
      openError("Ett fel uppstod när användaren skulle skapas", 6000);
    }
  };

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  const submit = () => {
    handleOnCreate();
  };

  useEffect(() => {
    fetchClients();
  }, []);

  if (loading) {
    return null;
  }

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, pt: 8, pb: 3, pl: 3, pr: 3 }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} md={12}>
              <Paper>
                <Typography
                  sx={{ marginBottom: "1.0rem" }}
                  variant="h5"
                  align="left"
                >
                  Skapa slutkund
                </Typography>
                <EndcustomerForm
                  formData={formData}
                  FORM_MODE={"CREATE"}
                  handleInputChange={handleInputChange}
                  agreementOptions={AGREEMENT_OPTIONS}
                  clients={clients}
                  boolOptions={BOOLVALUE}
                />

                <Grid
                  item
                  xs={12}
                  md={12}
                  sx={{
                    marginTop: 2,
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    onClick={onClose ? () => onClose() : () => navigate(-1)}
                  >
                    Stäng
                  </Button>
                  <LoadingButton
                    onClick={submit}
                    loading={loadingEndCustomers}
                    variant="contained"
                    sx={{ ml: 3 }}
                  >
                    Spara
                  </LoadingButton>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
